import { useState, useCallback } from 'react'
import { withUserContext, withUIContext } from 'context'
import { FormContainer, Input, ButtonSimple, Icon, Text } from 'components/common'
import Style from './style'

const ForgotPassword = ({ forgotPassword, closePopup }) => {
    const [thankYou, setThankYou] = useState(false)

    const handleForgotPassword = useCallback((values) => {
        return forgotPassword(values).then(() => {
            setThankYou(true)
        })
    }, [])

    return (
        <Style className={`parent-cont flexBoxColumn alignMiddle`}>
            <FormContainer className="forgot" onFinish={handleForgotPassword}>
                <div className="block">
                    <Icon className="op-close cursorPointer" onClick={closePopup} />
                    {thankYou ? (
                        <>
                            <Text tag={'h4'} className={'h4 PopSemi title'}
                                text={'Thank You'} />
                            <Text tag={'p'} className={'const14 PopReg grey subtitle'}
                                text={'We have emailed your password reset link!'} />
                            <ButtonSimple
                                className="done-btn"
                                text="Done"
                                onClick={closePopup}
                            />
                        </>

                    ) : (
                        <>
                            <Text
                                tag={'h4'}
                                className={'h4 PopSemi title'}
                                text={'Forgot Password'}
                            />
                            <Text
                                tag={'p'}
                                className={'const14 PopReg grey subtitle'}
                                text={'Please enter your email address to reset password'}
                            />
                            <Input name={'email'} placeholder="Email address" errorKey={'email'} />
                            <ButtonSimple
                                className="done-btn"
                                submit
                                text="Done"
                            />
                        </>
                    )}
                </div>
            </FormContainer>
        </Style>
    )
}

export default withUIContext(withUserContext(ForgotPassword, ['forgotPassword']), ['closePopup'])
